

import { Timestamp } from "firebase/firestore"
export class Company {
  constructor(
    company_id,
    name,
    company_code,
    company_type,
    disabled=false,
    notification_settings={
      delivery_settings: {
        delivery_method: "email",
        emails: [],
        phones: [],
      },
    },
    created_time=new Date(),
    updated_time=new Date(),
  ){
    this.company_id = company_id
    this.name = name
    this.company_code = company_code
    this.company_type = company_type
    this.disabled = disabled
    this.notification_settings = notification_settings
    this.created_time = created_time
    this.updated_time = updated_time
  }
}

export const CompanyConverter = {
  toFirestore: function(company) {
    console.log(company)
    return {
      company_id: company.company_id || null,
      name: company.name,
      company_code: company.company_code,
      company_type: company.company_type,
      disabled: company.disabled,
      notification_settings: company.notification_settings,
      created_time: Timestamp.fromDate(company.created_time || new Date()),
      updated_time: Timestamp.now(),
    };
  },
  fromFirestore: function(snapshot, options){
    const data = snapshot.data(options);
    return new Company(
      snapshot.id,
      data.name,
      data.company_code,
      data.company_type,
      data.disabled,
      data.notification_settings,
      data.created_time.toDate(),
      data.updated_time.toDate(),
    );
  }
}